import { generateTestId } from "@client-shared";

export const setRoasterLogoTestId = (identifier: string): string =>
  generateTestId("RoasterLogo", identifier);
